import { render, staticRenderFns } from "./SpotifyLoadMoreTracks.vue?vue&type=template&id=4fc35b89&"
import script from "./SpotifyLoadMoreTracks.vue?vue&type=script&lang=js&"
export * from "./SpotifyLoadMoreTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports